<div
  class="widget-container flex w-full flex-wrap"
  style="flex-direction: row"
  *ngIf="routeItem != null"
  [class.highlighted]="highlightedRoute"
>
  <div class="map-box">
    <!--    <span-->
    <!--      class="bg-purple-400 border-round-right-2xl px-2 py-1 text-white z-5"-->
    <!--      style="position: absolute; top: 10px; left: 0"-->
    <!--      ><i class="fa fa-star-o"></i> Planned Route</span-->
    <!--    >-->
    <supplier-jobs-inbox-item-map
      [routeId]="selectedRoute.id"
      [(selectedTaskId)]="chosenTaskId"
      [(taskMode)]="taskMode"
      [tasks]="routeTasks"
    >
    </supplier-jobs-inbox-item-map>
  </div>

  <div (dblclick)="viewRouteDetail($event)" class="task-info-box">
    <div style="width: 100%">
      <div class="widget-body style2023">
        <div>
          <div class="flex task-select-tabs">
            <div
              *ngFor="let task of routeTasks; let i = index"
              class="task-tab-item"
              [class.tab-highlighted]="highlightedTask == task.id"
              (click)="setHighlighted($event, task.id)"
            >
              Task {{ i + 1 }}
            </div>
          </div>
        </div>

        <div style="min-height: 278px">
          <div *ngFor="let routeTask of selectedRoute.recommendationTasks; let i = index">
            <div
              class="task-container"
              *ngIf="highlightedTask == routeTask.task.id"
              (click)="toggleMap($event, routeTask.task.id)"
              [class.unrotate]="showMapForTaskId != routeTask.task.id"
              [class.rotate]="showMapForTaskId == routeTask.task.id"
            >
              <div class="task-wrapper pl-3 pr-2">
                <task-vehicle-details
                  [task]="routeTask.task"
                  [showRegSearchLink]="true"
                  (searchByRegClicked)="searchByRegClicked.emit($event)"
                ></task-vehicle-details>
                <vertical-dots-container [position]="'start'" [narrowDots]="true">
                  <task-time-and-location-container
                    [styleType]="2"
                    [isFirstItem]="true"
                    [isLastItem]="false"
                    [isPickup]="true"
                    [task]="routeTask.task"
                    [taskNumber]="i + 1"
                    [location]="routeTask.task.pickupLocation"
                    [showTaskBadges]="true"
                    [earliestDateTime]="routeTask.pickupEarliestTime"
                    [latestDateTime]="routeTask.pickupLatestTime"
                    [isCarryOver]="routeTask.hasCarryover"
                  ></task-time-and-location-container>
                </vertical-dots-container>

                <vertical-dots-container
                  position="middle"
                  iconClass="fa fa-circle"
                  iconSize="tiny"
                  [narrowDots]="true"
                >
                  <task-divider
                    [showTime]="routeTask.task.estimateTime"
                    [showMiles]="routeTask.task.distance / 1609"
                  ></task-divider>
                </vertical-dots-container>

                <vertical-dots-container
                  [narrowDots]="true"
                  [iconClass]="i == routeTasks.length - 1 ? 'fa fa-circle' : 'fa fa-circle-o'"
                  [position]="'end'"
                >
                  <task-time-and-location-container
                    [styleType]="2"
                    [isFirstItem]="true"
                    [isLastItem]="true"
                    [isPickup]="false"
                    [taskNumber]="i + 1"
                    [location]="routeTask.task.dropoffLocation"
                    [task]="routeTask.task"
                    [earliestDateTime]="routeTask.dropoffEarliestTime"
                    [latestDateTime]="routeTask.dropoffLatestTime"
                  ></task-time-and-location-container>
                </vertical-dots-container>
              </div>
              <!--                                          <div-->
              <!--                                                  *ngFor="let x of task.checklistSubCategories"-->
              <!--                                                  style="margin-right: 7px; display: inline-block; padding-bottom: 10px"-->
              <!--                                          >-->
              <!--                                              <checklist-category-item-->
              <!--                                                      [subCategory]="x.checklistSubCategory"-->
              <!--                                              ></checklist-category-item>-->
              <!--                                          </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pricing-box">
    <div
      *ngIf="scheduleAlert"
      class="clash-indicator"
      [class.clash-indicator--error]="scheduleAlert.status === RouteAlertStatus.Error"
      [class.clash-indicator--warning]="scheduleAlert.status === RouteAlertStatus.Warning"
    >
      <i class="fa fa-calendar" aria-hidden="true"></i>
      <span class="clash-indicator__label">{{ scheduleAlert.title }}</span>
      <i
        class="fa fa-info-circle clash-indicator__info"
        aria-hidden="true"
        [pTooltip]="scheduleAlertTooltip"
        tooltipPosition="left"
        tooltipStyleClass="clash-tooltip"
      ></i>
    </div>
    <div class="pricing-box-content">
      <div class="flex justify-content-center pt-2 day-toggle-row">
        <route-day-toggle
          [variants]="toggleVariants"
          [selectedId]="selectedRoute.id"
          (variantSelected)="onVariantSelected($event)"
        ></route-day-toggle>
      </div>
      <div class="flex justify-content-center pt-2" *ngIf="selectedRoute.hasGrabbedTasks">
        <span *ngIf="selectedRoute.hasGrabbedTasks && !selectedRoute.routeGrabbed">
          <div class="inc-grabbed-task-pill">
            <i class="fa fa-link mr-1" aria-hidden="true"></i>
            <span>Extension</span>
          </div>
        </span>
      </div>
      <div class="flex justify-content-center pt-2" *ngIf="grabBonusCount > 0">
        <grab-bonus-badge [count]="grabBonusCount"></grab-bonus-badge>
      </div>
      <div class="pricing-box-inner">
        <div class="flex-grow-1 text-center job-total">
          <ng-container *ngIf="selectedRoute?.priceIncreasePercentage > 0; else noIncrease">
            <span class="price-increased">
              <svg class="price-increase-arrow" viewBox="0 0 24 24">
                <path d="M2 17l7-7 4 4 9-9M15 5h7v7" /></svg
              >&pound;{{ selectedRoute?.supplierPrice | number : '1.2-2' }}
            </span>
            <div class="price-increase-pill-row">
              <span class="price-increase-pill"
                >Increased by {{ selectedRoute.priceIncreasePercentage }}%</span
              >
            </div>
          </ng-container>
          <ng-template #noIncrease>
            <span>&pound;{{ selectedRoute?.supplierPrice | number : '1.2-2' }}</span>
          </ng-template>
        </div>
      </div>
      <div class="pricing-box-inner" style="padding-top: 0">
        <div class="flex-grow-1">
          <button
            pButton
            class="button-style ui-primary-button button-block primary-route-button"
            label="Grab Route"
            (click)="grabWithConfirmation()"
            *ngIf="!isVME"
          ></button>

          <div class="flex grid-gap-10 itinerary-action-row" *ngIf="!isVME">
            <div class="flex-grow-1">
              <button
                pButton
                *ngIf="!selectedRoute.hidden"
                class="button-style ui-secondary-button button-block"
                label="Hide"
                (click)="onHideRouteClicked.emit(selectedRoute.id)"
              ></button>
              <button
                pButton
                *ngIf="selectedRoute.hidden"
                class="button-style ui-secondary-button button-block"
                label="Hidden"
                (click)="unhideRoute()"
              ></button>
            </div>
            <div class="flex-grow-1">
              <button
                pButton
                *ngIf="!selectedRoute.watched"
                class="button-style ui-secondary-button button-block"
                label="Watch"
                (click)="watchRoute()"
              ></button>
              <button
                pButton
                *ngIf="selectedRoute.watched"
                class="button-style watching-button button-block"
                label="Watching"
                (click)="unwatchRoute()"
              ></button>
            </div>
          </div>

          <button
            pButton
            class="ui-primary-button button-block primary-route-button"
            label="Deploy Route"
            (click)="deployWithConfirmation()"
            *ngIf="isVME"
          ></button>

          <div class="flex grid-gap-3 itinerary-action-row">
            <button
              pButton
              (click)="showItineraryPopup()"
              icon="fa fa-list"
              class="ui-button-secondary itinerary-icon-button"
            ></button>
            <button
              (click)="viewRouteDetail($event)"
              pButton
              class="ui-button-secondary flex-grow-1"
              label="Route Details"
            ></button>
          </div>
        </div>
        <div class="supplier-info" *ngIf="isVME">
          <strong class="supplier-label">Supplier</strong>
          <span class="supplier-link" (click)="viewSupplier(routeItem?.supplierDetail.id)">
            <i class="fa fa-user-circle" aria-hidden="true"></i>
            {{ routeItem?.supplierDetail.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showGrabDeployConfirmDialog"
  [header]="grabDeployConfirmHeadline"
  [modal]="true"
  [style]="{ width: '480px' }"
  styleClass="grab-deploy-confirm-dialog"
  (onHide)="onGrabDeployConfirmHide()"
>
  <div class="confirm-dialog-body">
    <div class="confirm-summary">
      <div class="confirm-summary-label">Route Total</div>
      <div class="confirm-summary-price">
        &pound;{{ selectedRoute?.supplierPrice | number : '1.2-2' }}
      </div>
      <div *ngIf="grabDeployConfirmSubheadline" class="confirm-summary-subheadline">
        {{ grabDeployConfirmSubheadline }}
      </div>
    </div>

    <route-itinerary-alert *ngIf="scheduleAlert" [alerts]="[scheduleAlert]"></route-itinerary-alert>
  </div>
  <p-footer>
    <div class="confirm-dialog-footer">
      <button
        pButton
        type="button"
        label="Cancel"
        class="ui-button-secondary"
        (click)="onGrabDeployConfirmCancel()"
      ></button>
      <button
        pButton
        type="button"
        [label]="grabDeployConfirmAcceptLabel"
        class="ui-primary-button"
        (click)="onGrabDeployConfirmAccept()"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<route-itinerary-popup
  *ngIf="showRouteItineraryPopup"
  [(showDialog)]="showRouteItineraryPopup"
  [selectedRoute]="selectedRoute"
  (alternateRouteSelected)="onAlternateRouteSelected($event)"
  (closeDialog)="closeItineraryPopup()"
  (routeDetailClick)="openRouteDetailInNewTab()"
  (grabOrDeployRouteClick)="onGrabOrDeployRouteFromPopupClick()"
  [isVME]="isVME"
></route-itinerary-popup>

<app-route-itinerary-confirm-start-date
  *ngIf="showConfirmStartDatePopup"
  [(showConfirmStartDateDialog)]="showConfirmStartDatePopup"
  [routeId]="this.selectedRoute?.id"
  (grabOrDeployClicked)="onGrabOrDeployRouteFromConfirmStartDateClick()"
  (selectedDateChange)="onAlternateDateSelected($event)"
  [isVME]="isVME"
  [supplierName]="routeItem?.supplierDetail.name"
></app-route-itinerary-confirm-start-date>

<route-itinerary-confirmation-popup
  *ngIf="showConfirmationPopup"
  [(showConfirmationDialog)]="showConfirmationPopup"
  [jobId]="this.grabbedJobId"
  [isVME]="isVME"
>
</route-itinerary-confirmation-popup>
